import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import ModalRoot from './components/common/ModalRoot';
import ToastsContainer from './components/common/ToastsContainer';
import '@zola/components-wedding/dist/index.css';

function App({ children }) {
  return (
    <div id="zola-wedding-container">
      <Helmet
        meta={[
          {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1, maximum-scale=5',
          },
        ]}
      />
      {children}
      <ModalRoot />
      <ToastsContainer />
      <div id="tooltipRoot" />
    </div>
  );
}

App.propTypes = {
  children: PropTypes.element.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx